import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';
import type {
  VideoPlayerDefinition,
  VideoPlayerProps,
} from '../VideoPlayer.types';
import { getPlayerName } from './utils';
import { props as viewerPropsMapper } from './VideoPlayer.mapper';

const props = composeMapper<
  PreviewWrapperProps<VideoPlayerProps>,
  VideoPlayerDefinition
>()(
  viewerPropsMapper,
  { add: ['isPlayingAllowed', 'shouldResetComponent', 'componentViewMode'] },
  (resolver, deps, carmiData) => {
    const viewerProps = viewerPropsMapper.resolver(deps, carmiData);
    const { isPlayingAllowed, shouldResetComponent, componentViewMode } = deps;
    const isTwitch = getPlayerName(viewerProps.src) === 'twitch';
    return {
      ...viewerProps,
      // Allows twitch iframe to load from `editor.wix.com` instead of `wix.com`
      twitchParentDomains: isTwitch ? [window.location.hostname] : undefined,
      previewWrapperProps: {
        isPlayingAllowed,
        shouldResetComponent,
        componentViewMode,
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
